import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import UserContext from './context/UserContext';
import { Role } from 'src/Role';

const DASHBOARD_STATS_PATHS = [
  '/',
  '/dashboards/analytics',
  '/admin/analytics',
  '/management/statistics'
];

const VerifyRole: React.FC<{ element; allow  }> = ({
  element,
  allow
}): any => {

  const [user] = useContext(UserContext);
  const location = useLocation();
  const role = user && user?.role;
  const isDashboardOrStatsPath = DASHBOARD_STATS_PATHS.includes(
    location.pathname
  );
  const matchesAllow =
    role === allow ||
    (allow === Role.SUPER_ADMIN &&
      role === Role.DEVELOPMENT_TEAM &&
      !isDashboardOrStatsPath);

  if (!role) {
    console.log("data1",allow,role)
    return true;
  } else if (user?.verifiedStatus == 'PENDING') {
    localStorage.clear();
    sessionStorage.clear();
     console.log('data2', allow, role);
    return <Navigate to={'/sign-in'} />;
  }
  else if (allow && !matchesAllow) {
    console.log('data3', allow, role);
    return <Navigate to={'/page-not-found'} />;
  }
  else if (allow && allow == Role.CUSTOMER && user?.isWebAccess && role == Role.CUSTOMER) {
    console.log('data4', allow, role);
    return element;
  }
  else if (allow && matchesAllow) {
      console.log('data5', allow, role);
      switch (role) {
        case Role.SUPER_ADMIN:
          return element;
        case Role.DEVELOPMENT_TEAM:
          return element;
        case Role.INVENTORY_ADMIN:
          return element;
        case Role.CUSTOMER_SUPPORT:
          return element;
        default:
           <Navigate to={'/page-not-found'} />;
      }
  }
  else {
      console.log('data6', allow, role);
    localStorage.clear();
    sessionStorage.clear();
     return <Navigate to={'/sign-in'} />;
  }
};
export default VerifyRole;
